import { render, staticRenderFns } from "./file-single.vue?vue&type=template&id=52f6cffa&"
import script from "./file-single.vue?vue&type=script&lang=js&"
export * from "./file-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports